import React, { useEffect, useState, useCallback } from 'react';
import {
    IonContent,
    IonPage,
    IonImg,
    IonIcon,
    IonLoading, useIonAlert, IonRow, IonCol,
} from '@ionic/react';
import {
    chevronBack,
    chevronForward,
    addCircle, trash, eye, pencil, addCircleOutline, addOutline
} from 'ionicons/icons';

import AddNewsModal from "../../components/AddNewsModal";
import useStore from "../../zustand/useStore";
import {
    actionToDeleteNewsPostData, actionToGetAllNewsCategoriesAdmin,
    actionToGetNewsByFilter
} from "../../apiHelpers/CommonAction";
import {FacebookLoader} from "../../components/Loader/FacebookLoader";
import {_getNewsCategories} from "../../apiHelpers/CommonHelper";
import NewsDetailSheetModal from "../../components/NewsDetailSheetModal";
import AddNewsCategoryModal from "../../components/AddNewsCategoryModal";

const ITEMS_PER_PAGE = 10;

const AdminHomePage = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [addNewsModalSheet, setAddNewsModalSheet] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [addEditCategoryModal, setAddEditCategoryModal] = useState(false);

    const { newsDataState } = useStore(); // ✅ use new state
    const { newsData, loading, totalCount } = newsDataState;
    const [presentAlert] = useIonAlert();
    const pageCount = Math.ceil((totalCount || 0) / ITEMS_PER_PAGE);
    const [selectedCategory, setSelectedCategory] = useState("");
    const [selectedMonth, setSelectedMonth] = useState("");
    const [dateRange, setDateRange] = useState({ from: "", to: "" });
    const [newsDetailsData, setNewsDetailsData] = useState(null);
    const [isDetailOpen, setIsDetailOpen] = useState(false);
    const [dataForEditing,setDataForEditing] = useState(null);

    const fetchPageData = useCallback((page) => {
        const newOffset = (page - 1) * ITEMS_PER_PAGE;
        setCurrentPage(page);

        actionToGetNewsByFilter(false, {
            offset: newOffset,
            category: selectedCategory || undefined,
            month: selectedMonth || undefined,
            from_date: dateRange.from || undefined,
            to_date: dateRange.to || undefined,
        });
    }, [selectedCategory, selectedMonth, dateRange]);


    useEffect(() => {
        fetchPageData(1);
    }, [fetchPageData]);

    const handlePrev = () => {
        if (currentPage > 1) {
            fetchPageData(currentPage - 1);
        }
    };


    const callFunctionToSetEditData = (data)=>{
        setDataForEditing(data);
        setAddNewsModalSheet(true);
    }

    const handleNext = () => {
        if (currentPage < pageCount) {
            fetchPageData(currentPage + 1);
        }
    };

    const openDetailPanel = (jobDetail) => {
        setNewsDetailsData(jobDetail);
        setIsDetailOpen(true);
    }

    const callFunctionToDeletedata = (id)=>{
        presentAlert({
            header: 'Are you sure?',
            cssClass: 'custom_site_alert_toast',
            message: 'You want to delete this item.',
            buttons: [
                {text: 'Cancel', role: 'cancel'},
                {text: 'Delete', role: 'confirm', handler: async () =>{
                        await actionToDeleteNewsPostData(id)
                    }},
            ],
        });
    }

    const clearFilters = () => {
        setSelectedCategory("");
        setSelectedMonth("");
        setDateRange({ from: "", to: "" });
        fetchPageData(1); // reload without filters
    };

    return (
        <IonPage>
            <IonContent className="ion-padding news-letter-content-page container">
                <div className="admin_inner_tab_container">
                    <div className="header-row">
                        <h2 className="newsletter-heading">All News</h2>
                    </div>
                    <IonRow>
                        <IonCol size={"12"} sizeMd={"12"}>
                            <div className="newsletter-table-container">
                                <div className={"d-flex justify-between admin-home-filter-row"}>
                                    <div className="filters-row admin_datatable_filter">
                                    {/* Category Filter */}
                                    <select
                                        value={selectedCategory}
                                        onChange={(e) => setSelectedCategory(e.target.value)}
                                    >
                                        <option value="">All Categories</option>
                                        {(_getNewsCategories?.map((cat)=>(
                                            <option value={cat} key={cat}> {cat.replace(/-/g, " ").replace(/\b\w/g, l => l.toUpperCase())}</option>
                                        )))}
                                    </select>

                                    {/* Month Filter */}
                                    <select
                                        value={selectedMonth}
                                        onChange={(e) => setSelectedMonth(e.target.value)}
                                    >
                                        <option value="">All Months</option>
                                        <option value="1">January</option>
                                        <option value="2">February</option>
                                        <option value="3">March</option>
                                        <option value="4">April</option>
                                        <option value="5">May</option>
                                        <option value="6">June</option>
                                        <option value="7">July</option>
                                        <option value="8">August</option>
                                        <option value="9">September</option>
                                        <option value="10">October</option>
                                        <option value="11">November</option>
                                        <option value="12">December</option>
                                    </select>

                                    {/* Date Range Filter */}
                                    <input
                                        type="date"
                                        value={dateRange.from}
                                        onChange={(e) => setDateRange({...dateRange, from: e.target.value})}
                                    />
                                    <input
                                        type="date"
                                        value={dateRange.to}
                                        onChange={(e) => setDateRange({...dateRange, to: e.target.value})}
                                    />

                                    <button
                                        className="clear_button"
                                        onClick={clearFilters}
                                    >
                                        Clear All
                                    </button>

                                </div>
                                    <div className={"right_side_button_section_admin_table"}>
                                        <button className="add_new_category_button_admin" onClick={()=>setAddEditCategoryModal(true)}>
                                            Categories
                                        </button>
                                        <IonIcon
                                            className="add_news_icon addnews-btn"
                                            onClick={() => setAddNewsModalSheet(true)}
                                            icon={addOutline}
                                        />
                                    </div>
                                </div>

                                <table className="newsletter-table">
                                    <thead>
                                    <tr>
                                        <th>Image</th>
                                        <th>Title</th>
                                        <th>Created At</th>
                                        <th>Action</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {(loading) ?
                                        <>
                                            <tr>
                                                <td>
                                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                                </td>
                                                <td>
                                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                                </td>
                                                <td>
                                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                                </td>
                                                <td>
                                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                                </td>
                                                <td>
                                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                                </td>
                                                <td>
                                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                                </td>
                                                <td>
                                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                                </td>
                                                <td>
                                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                                </td>
                                                <td>
                                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                                </td>
                                                <td>
                                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                                </td>
                                                <td>
                                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                                </td>
                                                <td>
                                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                                </td>
                                                <td>
                                                    <FacebookLoader type={"facebookStyle"} item={1}/>
                                                </td>
                                            </tr>
                                        </>
                                        :(newsData?.length > 0) ? (
                                            newsData.map((item) => (
                                                <tr key={item.id}>
                                                    <td>
                                                        <IonImg src={item.image_url} className="newsletter-img" />
                                                    </td>
                                                    <td>{item.title}</td>
                                                    <td>{new Date(item.created_at).toLocaleDateString()}</td>
                                                    <td className={"action_td"}>
                                                        <IonIcon icon={eye} onClick={()=>openDetailPanel(item)} className={"admin_delete_button_icon eye_icon"}/>
                                                        <IonIcon icon={pencil} onClick={()=>callFunctionToSetEditData(item)} className={"admin_delete_button_icon pencil_icon"}/>
                                                        <IonIcon icon={trash} onClick={()=>callFunctionToDeletedata(item?.id)} className={"admin_delete_button_icon"}/>
                                                    </td>
                                                 </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="3" style={{ textAlign: 'center', padding: '1rem' }}>
                                                    No news found.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </IonCol>
                    </IonRow>


                    {/* Pagination Controls */}
                    <div className="pagination-controls">
                        <button
                            type="button"
                            className={"pagination_button"}
                            disabled={currentPage === 1}
                            onClick={handlePrev}
                        >
                            <IonIcon icon={chevronBack} />
                        </button>
                        <span className="page-info">
                            Page {currentPage} of {pageCount}
                        </span>
                        <button
                            type="button"
                            className={"pagination_button"}
                            disabled={currentPage === pageCount}
                            onClick={handleNext}
                        >
                            <IonIcon icon={chevronForward} />
                        </button>
                    </div>
                </div>
            </IonContent>

            {/* Add News Modal */}
            <AddNewsModal
                isOpen={addNewsModalSheet}
                dataForEditing={dataForEditing}
                onClose={() => setAddNewsModalSheet(false)}
                setIsLoading={setIsLoading}
            />

            <AddNewsCategoryModal
                isOpen={addEditCategoryModal}
                onClose={() => setAddEditCategoryModal(false)}
            />

            <NewsDetailSheetModal isOpen={isDetailOpen}
                                  newsDetailsData={newsDetailsData}
                                  onDidDismiss={() => setIsDetailOpen(false)}/>


            <IonLoading
                isOpen={isLoading}
                className="loading_loader_spinner_container 5"
                message="Please Wait..."
            />
        </IonPage>
    );
};

export default AdminHomePage;
